export const CityDataNew = [
  "18-Hazari",
  "Abbottabad",
  "Ahmad pur sial",
  "Ahmadpur Sharqia",
  "Ahmedpur East",
  "Alipur",
  "Allai",
  "Arifwala",
  "Askole",
  "Astore",
  "Athmuqam",
  "Attock",
  "Awaran",
  "Badin",
  "Bahawalnagar",
  "Bahawalpur",
  "Bajaur",
  "Bannu",
  "Barkhan",
  "Batagram",
  "Bagh",
  "Bhakkar",
  "Bhalwal",
  "Bhera",
  "Bhimber",
  "Bhowana",
  "Buner",
  "Burewala",
  "Karachi Central",
  "Central Dir",
  "Chagai",
  "Chak Jhumra",
  "Chakwal",
  "Chaman",
  "Charsadda",
  "Chawk Sarwar Shaheed",
  "Chichawatni",
  "Chilas",
  "Chiniot",
  "Chishtian",
  "Chitral",
  "Choa Saidan Shah",
  "Choubara",
  "Chunian",
  "Dadyal",
  "Danyor",
  "Darya Khan",
  "Daska",
  "Depalpur",
  "Dera Allah Yar",
  "Dera Bugti",
  "Dera Ghazi Khan",
  "Dera Ismail Khan",
  "Dera Murad Jamali",
  "Diamir",
  "Dina",
  "Dipalpur",
  "Duki",
  "Karachi East",
  "Faisalabad",
  "Faisalabad sadar",
  "Farooqabad",
  "Fateh Jang",
  "Ferozwala",
  "Fort Abbas",
  "Ghotki",
  "Gilgit",
  "Gojra",
  "Gupis-Yasin",
  "Gujar Khan",
  "Gujranwala",
  "Gujranwala Cantonment",
  "Gujranwala City",
  "Ghizer",
  "Gujranwala Saddar",
  "Gulmit",
  "Gwadar",
  "Gujrat",
  "Nankana Sahib",
  "Hafizabad",
  "Hangu",
  "Haripur",
  "Harnai",
  "Haroonabad",
  "Hasilpur",
  "Hassan Abdal",
  "Hattian Bala",
  "Haveli Lakha",
  "Hazara",
  "Haveli",
  "Hazro",
  "Hub District",
  "Hyderabad",
  "Isa Khe",
  "Islamabad",
  "Jacobabad",
  "Jaffarabad",
  "Jaglot",
  "Jahanian",
  "Jalal Abad",
  "Jalalpur Jattan",
  "Jalalpur Pirwala",
  "Jalalpur Priwala",
  "Jampur",
  "Jamshoro",
  "Jand",
  "Jaranwala",
  "Jatoi",
  "Jauharabad",
  "Jhal Magsi",
  "Jhang",
  "Jhelum",
  "Kabirwala",
  "Kachhi",
  "Kahuta",
  "Kalat",
  "Kallar Kahar",
  "Kallar Syedan",
  "Kallur Kot",
  "Kamalia",
  "Kamoke",
  "Karachi",
  "Karak",
  "Karezat",
  "Kalam",
  "Karimabad",
  "Karor Lal Esan",
  "Kashmore",
  "Kasur",
  "Kech",
  "Kehror Pacca",
  "Kemari",
  "Khairpur",
  "Khanewal",
  "Khanpur",
  "Khaplu",
  "Kharan",
  "Kharfaq",
  "Kharian",
  "Khushab",
  "Khuzdar",
  "Khyber",
  "Killa Abdullah",
  "Koh-e-Suleman",
  "Kohat",
  "Kohlu",
  "Kolai-Palas",
  "Korangi",
  "Kot Abdul Malik",
  "Kot Addu",
  "Kot Chutta",
  "Kot Momin",
  "Kot Radha Kishan",
  "Kotli",
  "Kotli Sattian",
  "Kotri",
  "Kunjah",
  "Kurram",
  "Lahore",
  "Lakki Marwat",
  "Lala Musa",
  "Lalian",
  "Larkana",
  "Lasbela",
  "Lawa",
  "Layyah",
  "Lehri",
  "Liaquatpur",
  "Lodhran",
  "Loralai",
  "Lower Chitral",
  "Lower Dir",
  "Lower Kohistan",
  "Lower South Waziristan",
  "Ludhewala Waraich",
  "Mailsi",
  "Malakand",
  "Malakwal",
  "Malir",
  "Mandi Bahauddin",
  "Mankera",
  "Mansehra",
  "Mardan",
  "Mastung",
  "Matiari",
  "Malam Jabba",
  "Mian Channu",
  "Mianwali",
  "Minchinabad",
  "Minimarg",
  "Mirpur Khas",
  "Misgar",
  "Modal Town",
  "Mohmand",
  "Multan",
  "Multan Saddar",
  "Muridke",
  "Murree",
  "MirPurKhas",
  "Musakhail",
  "Muzaffarabad",
  "Muzaffargarh",
  "Nagar Khas",
  "Naltar Valley",
  "Narowal",
  "Naseerabad",
  "Nagar",
  "Nasirabad",
  "Naushahro Feroze",
  "Naushera",
  "Nawabshah",
  "New Mirpur City",
  "Nishtar",
  "Noorpur Thal",
  "North Waziristan",
  "Nowshera",
  "Nowshera Virkan",
  "Nushki",
  "Okara",
  "Orakzai",
  "Oshikhandass",
  "Pakpattan",
  "Pallandri",
  "Panjgur",
  "Pasrur",
  "Pattoki",
  "Peshawar",
  "Phalia",
  "Phander",
  "Phool Nagar",
  "Pind Dadan Khan",
  "Pindi Bhattian",
  "Pindi Gheb",
  "Piplan",
  "Pir Mahal",
  "Pishin",
  "Qambar Shahdadkot",
  "Quaidabad",
  "Quetta",
  "Rahim Yar Khan",
  "Raiwind",
  "Rajanpur",
  "Rakhshan",
  "Ravi",
  "Rawalakot",
  "Rawalpindi",
  "Renala Khurd",
  "Rojhan",
  "Sadiqabad",
  "Safdarabad",
  "Sahiwal",
  "Sambrial",
  "Samundri",
  "Sanghar",
  "Sangla Hill",
  "Sarai Alamgir",
  "Sudhnoti",
  "Sargodha",
  "Shahdadkot",
  "Shahdadpur",
  "Shaheed Benazir Abad",
  "Shahpur",
  "Shakargarh",
  "Shalimar",
  "Shangla",
  "Sharaqpur",
  "Sheikhupura",
  "Shigar",
  "Shigar ",
  "Shikarpur",
  "Shimshal",
  "Shorkot",
  "Shujabad",
  "Sialkot",
  "Sibi",
  "Sillanwali",
  "Sohawa",
  "Sohbatpur",
  "Sost",
  "Karachi South",
  "Sujawal",
  "Sukkur",
  "Sultan Abad",
  "Surab",
  "Swabi",
  "Swat",
  "Talagang",
  "Tandlianwala",
  "Tando Allahyar",
  "Tando Muhammad Khan",
  "Tank",
  "Taunsa Sharif",
  "Taxila",
  "Thalichi",
  "Tharparkar",
  "Thatta",
  "Toba Tek Singh",
  "Tolti",
  "Turbat",
  "Tor Ghar",
  "Umerkot",
  "Upper Chitral",
  "Upper Dir",
  "Upper Kohistan",
  "Upper South Waziristan",
  "Usta Muhammad",
  "Vehari",
  "Wah Cantonment",
  "Washuk",
  "Wazirabad",
  "Karachi West",
  "Yazman",
  "Zafarwal",
  "Zhob",
  "Ziarat",
]; 